import React, { Component } from 'react';

import API from 'API';

import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class ChimneyDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const chimneyTypes = await API.call('book/list-chimney-types');
        this.setState({
            chimneyTypes,
            isLoading: false
        });
    }

    selectChimneyType(chimneyTypeID) {
        const { onChange } = this.props;
        this.setState({ isBusy: true });
        onChange({
            chimneyTypeID
        }, async () => {
            await API.call('book/update-chimney-details', this.props.bookingRequest);
            this.setState({ isBusy: false });
            this.props.onChimneyTypeSelected();
        });
    }

    render() {
        const { isLoading, chimneyTypes, isBusy } = this.state;
        const { onBackClicked, bookingRequest } = this.props;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <h2>What kind of chimney do you have?</h2>

            <div className="btn-stack">

                {chimneyTypes.map(ct =>
                    <button
                        key={ct.id}
                        type="button"
                        className={`btn btn-secondary chimney-type-btn ${ct.id == bookingRequest.chimneyTypeID ? 'selected' : ''    }`}
                        onClick={() => this.selectChimneyType(ct.id)}
                        disabled={isBusy}
                    >
                        <div className="chimney-type-name">
                            {ct.name}
                            {/*
                            {ct.id == bookingRequest.chimneyTypeID && <>
                                {' '}
                                <span className="fa fa-check" />
                            </>}
                            */}
                        </div>
                        <div className="chimney-type-description">
                            {ct.description}
                        </div>
                    </button>
                )}

                <button
                    type="button"
                    className="btn btn-secondary chimney-type-btn"
                    onClick={() => this.selectChimneyType(null)}
                    disabled={isBusy}
                >
                    <div className="chimney-type-name">
                        I Don't Know / Other
                    </div>
                    <div className="chimney-type-description">
                        Don't know what type of chimney you've got, or not listed here? Don't worry.
                    </div>
                </button>

            </div>
            
            <div className="nav-buttons">

                <button type="button" className="btn btn-secondary me-auto" onClick={() => onBackClicked()} disabled={isBusy}>
                    Back
                </button>

            </div>

        </>);
    }

}

export default ChimneyDetails;